import api from 'api'

export type CreateIndeedFlexCompanyParams = {
  ifClientId: number
  companyId: number
  canCreateShifts?: boolean
  fileHandleId?: number
  shiftNotificationTitle?: string | null
  shiftNotificationMessage?: string | null
  shiftNotificationDeliveryHour?: number | null
}

export type CreateIndeedFlexCompanyResponse = {
  id: number
}

export const createIndeedFlexCompany = async (
  params: CreateIndeedFlexCompanyParams
): Promise<CreateIndeedFlexCompanyResponse> => {
  const result = await api.post<CreateIndeedFlexCompanyResponse>(
    '/admin/indeed_flex/companies',
    params
  )
  return result.data
}
